import type { ObjectDirective } from 'vue'
import { nextTick } from 'vue'

/**
 * Focuses the element when the binding value is truthy.
 * Vue 3 equivalent of ecomm-prev v-focus. Used for roving tabindex / keyboard
 * navigation where focus must follow programmatic state (e.g. arrow keys).
 */
const focus: ObjectDirective<HTMLElement, boolean | undefined> = {
  mounted(el, { value }) {
    if (value) el.focus()
  },
  updated(el, { value }) {
    if (value) nextTick(() => el.focus())
  },
}

export default focus
